import { FORM_TYPES_CONTENT_NAME, FormTypes } from '../models/forms.model';
import { Observable, of } from 'rxjs';

import { FilesViewerFile } from '@arsultima/file-viewer';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { NavigateService } from '../core/authentication/services/navigate/navigate.service';
import { SAVE_SUBMISSION_ERROR } from './../config/errors.config';
import { SlideshowService } from '../modules/slideshow/services/slideshow.service';
import { URL_ROUTER } from '../utils/url-router';
import { ViewportScroller } from '@angular/common';
import { SnackbarService } from '../core/services/snackbar.service';

export interface ClickToZoomPayload {
  images: FilesViewerFile[];
}

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(
    private readonly scroller: ViewportScroller,
    private readonly slideshowService: SlideshowService,
    private readonly navigateService: NavigateService,
    private readonly snackbarService: SnackbarService,
  ) {}

  showMessage(message: string): void {
    this.snackbarService.success(message);
  }

  showSaveSuccessMessage(formType: string): void {
    const content = formType || 'form';
    this.snackbarService.success(`messages.${content}`);
  }

  doAfterFormSaved(form: FormGroup, formType: FormTypes) {
    // Mark as pristine to mark the form as saved
    form.markAsPristine();

    // Show a confirmation message after the form was submitted
    const { name } = FORM_TYPES_CONTENT_NAME[formType];
    this.showSaveSuccessMessage(name);
  }

  scrollToTop() {
    this.scroller.scrollToPosition([0, 0]);
  }

  clickZoomImage({ images }: ClickToZoomPayload) {
    this.slideshowService.setImages(images);

    this.navigateService.navigate(URL_ROUTER.viewer());
  }

  // Return value to be precised either SAVE_SUBMISSION_ERROR or a response object depending of the save service
  saveBeforeDoingOtherAction(form: FormGroup, saveService: any): Observable<any> {
    if (this.isFormValid(form)) {
      return this.saveFormProgrammatically(form, saveService);
    } else {
      return this.warnUserOfFormSubmissionFailure(form);
    }
  }

  warnUserOfFormSubmissionFailure(form: FormGroup) {
    // Mark all fields as touched to show errors
    form.markAllAsTouched();
    form.markAsDirty();
    this.snackbarService.error('messages.formSubmissionFailure');

    this.scrollToTop();
    return of(SAVE_SUBMISSION_ERROR);
  }

  saveFormProgrammatically(form: FormGroup, saveService: any): Observable<any> {
    const formData = form.getRawValue();
    return this.isFormDirty(form) ? saveService(formData) : of(null);
  }

  private isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  private isFormDirty(form: FormGroup): boolean {
    return form.dirty;
  }
}
